import HeadTittle from '../../../components/HeadTittle';
import routes from '../../../Routes/routes';
import {AddIcon, QrIcon} from '../../../components/buttons/IconButtons';
import ButtonAction from '../../../components/buttons/ButtonAction';
import MaterialRequestSection from "./SubComponents/MaterialRequest/MaterialRequestSection";
import VehicleMovementsTable from "./SubComponents/VehicleMovements/VehicleMovementsTable";
import {MaterialControlMainApp} from "./Functionality/MaterialControlMainApp";
import StepperTabs from "../../../components/StepperTabs/StepperTabs";
import StepTab from "../../../components/StepperTabs/StepTab";
import React from "react";
import {MATERIAL_CONTROL_TABS, TAB_PERMISSION_MATERIAL_CONTROL, TAB_READ_PERMISSION_MATERIAL_CONTROL} from "./Model/Model";
import EntryAndExitFormsTable from "./SubComponents/EntryAndExitForms/EntryAndExitFormsTable";
import ExportDataBtn from "../../../components/buttons/ExportDataBtn";
import SearchFilterBtn from "../../../components/buttons/SearchFilterBtn";
import SearchFor from "../../Modals/SearchFor";

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
const MaterialControlMain = () => {
    const {
        navigate,
        permission,
        DEV,
        steps,
        activeStep,
        setActiveStep,
        searchElement,
        setSearchElement,
        setSearch,
        simpleSearch,
        setSimpleSearch,
        setModuleId,
        option,
        setOption,
        subView,
        setSubView,
        finalArray,
        setFinalArray,
        filterDialogShow,
        setFilterDialogShow,
        modified,
        setModified,
        setBodyForExport,
        bodyForExport,
        criteria,
        setCriteria,
        moduleId,
        search,
        isAllChecked,
        setIsAllChecked,
        selectedList,
        setSelectedList,
        showCreateModal,
        setShowCreateModal,
        handleStepChange,
        permissionButtons,
        goCreate,
        isTabReady,
        isGuard,
        searchUserId
    } = MaterialControlMainApp();

    // Every tab is a module of its own, so the view is read by whoever reads at
    // least one of them. A guard carries no permissions, its user type reads it.
    const canReadAnyTab = isGuard || Object.values(TAB_READ_PERMISSION_MATERIAL_CONTROL)
        .some(p => permission?.includes(p));

    if (!DEV && !canReadAnyTab)
        navigate(routes.forbidden);

    return (
        <>
            <HeadTittle name={'material_control'}>

                {/* The guard identifies the folio at the gate by its QR code, so the
                    scanner is offered to the guard, and it returns here once it is left */}
                {isGuard &&
                    <ButtonAction
                        id='btn_mc_qr_scanner'
                        name='qr_scanner'
                        splitName={false}
                        className='btn-icon-accent-450'
                        Icon={QrIcon}
                        url={routes.materialRequest.scanner}
                        state={{backUrl: routes.materialControl.main}}
                    />
                }

                {/* The table of the tab is the one that is exported, so the
                    action is only offered by the tabs that declare a module of
                    their own to generate the file with. The file is read for the
                    user that exports it, and the guard reads every folio without
                    a user, so the action is not offered to the guard. */}
                {permissionButtons(TAB_PERMISSION_MATERIAL_CONTROL(subView).EXPORT) &&
                    <ExportDataBtn
                        id={'btn_mr_export'}
                        moduleId={moduleId}
                        option={option}
                        search={search}
                        body={search ? criteria : bodyForExport}
                        searchElement={searchElement}
                        contractorSupplier={false}
                    />
                }

                {/* Every tab is filtered with the module of its own table, so the
                    search is offered once the tab points at the module it reads.
                    The guard only reads the folios with the simple search. */}
                {!isGuard && moduleId && option &&
                    <SearchFilterBtn
                        id={'btn_mc_search'}
                        finalArray={finalArray}
                        fnclick={() => setFilterDialogShow(true)}
                    />
                }

                {permissionButtons(TAB_PERMISSION_MATERIAL_CONTROL(subView).CREATE) &&
                    <ButtonAction
                        id='btn_mr_create'
                        name='create'
                        className='btn-icon-add'
                        Icon={AddIcon}
                        onClick={goCreate}
                    />
                }

            </HeadTittle>
            <StepperTabs
                onlyTab={true}
                disabled={false}
                steps={steps}
                activeStep={activeStep}
                isStepOptional={() => {}}
                setActiveStep={setActiveStep}
                handleStepChange={handleStepChange}
            >
                <StepTab index={MATERIAL_CONTROL_TABS.ENTRY_AND_EXIT_FORMS.INDEX} activeStep={activeStep} normalHeight={true}>
                    {isTabReady(MATERIAL_CONTROL_TABS.ENTRY_AND_EXIT_FORMS.INDEX) &&
                        <EntryAndExitFormsTable
                            selectedList={selectedList}
                            setSelectedList={setSelectedList}
                            isAllChecked={isAllChecked}
                            setIsAllChecked={setIsAllChecked}
                            option={option}
                            setBodyForExport={setBodyForExport}
                            searchElement={searchElement}
                            setSearchElement={setSearchElement}
                            setSearch={setSearch}
                            setSimpleSearch={setSimpleSearch}
                            finalArray={finalArray}
                            modified={modified}
                            setModified={setModified}
                            setCriteria={setCriteria}
                            showCreateModal={showCreateModal}
                            setShowCreateModal={setShowCreateModal}
                        />
                    }
                </StepTab>
                <StepTab index={MATERIAL_CONTROL_TABS.VEHICLE_MOVEMENTS.INDEX} activeStep={activeStep} normalHeight={true}>
                    {isTabReady(MATERIAL_CONTROL_TABS.VEHICLE_MOVEMENTS.INDEX) &&
                        <VehicleMovementsTable
                            selectedList={selectedList}
                            setSelectedList={setSelectedList}
                            isAllChecked={isAllChecked}
                            setIsAllChecked={setIsAllChecked}
                            option={option}
                            setBodyForExport={setBodyForExport}
                            searchElement={searchElement}
                            setSearchElement={setSearchElement}
                            setSearch={setSearch}
                            setSimpleSearch={setSimpleSearch}
                            finalArray={finalArray}
                            modified={modified}
                            setModified={setModified}
                            setCriteria={setCriteria}
                        />
                    }
                </StepTab>
                <StepTab index={MATERIAL_CONTROL_TABS.REQUESTS.INDEX} activeStep={activeStep} normalHeight={true}>
                    {isTabReady(MATERIAL_CONTROL_TABS.REQUESTS.INDEX) &&
                    <MaterialRequestSection
                        subView={subView}
                        setSubView={setSubView}
                        setOption={setOption}
                        setModuleId={setModuleId}
                        setFinalArray={setFinalArray}
                        selectedList={selectedList}
                        setSelectedList={setSelectedList}
                        isAllChecked={isAllChecked}
                        setIsAllChecked={setIsAllChecked}
                        option={option}
                        setBodyForExport={setBodyForExport}
                        searchElement={searchElement}
                        setSearchElement={setSearchElement}
                        setSearch={setSearch}
                        simpleSearch={simpleSearch}
                        setSimpleSearch={setSimpleSearch}
                        finalArray={finalArray}
                        modified={modified}
                        setModified={setModified}
                        setCriteria={setCriteria}
                    />
                    }
                </StepTab>
            </StepperTabs>

            {(filterDialogShow || finalArray?.length > 0) &&
                <SearchFor
                    open={filterDialogShow}
                    onClose={() => setFilterDialogShow(false)}
                    onFiltered={(originalArray) => {
                        setFilterDialogShow(false);
                        setFinalArray(originalArray);
                        setSearchElement('');
                    }}
                    moduleId={`${moduleId}`}
                    option={option}
                    finalArray={finalArray}
                    cleanAdvance={modified}
                    setCleanAdvance={setModified}
                    search={search}
                    setSearch={setSearch}
                    setFinalArray={setFinalArray}
                    searchElement={searchElement}
                    userId={searchUserId}
                />
            }
        </>
    );
};

export default MaterialControlMain;
